
import { Language } from './Language';
import { fr } from './fr';
import { en } from './en';

export default class Loc {

    static myInstance: Loc;
    public language: Language = new en();
    public languages: Language[] = [new en(), new fr()];

    /**
     * @returns {Loc}
     */
    static get() {
        if (Loc.myInstance == null) {
            Loc.myInstance = new Loc();
        }

        return this.myInstance;
    }

    static changeLanguage(language: string){
        if (Loc.myInstance == null) {
            Loc.myInstance = new Loc();
        }

        let langSimple = language.substring(0, 2).toLowerCase();
        localStorage.setItem('language', langSimple);

        switch(langSimple)
        {
            case "fr":
                this.myInstance.language = new fr();
                break;
            default:
                localStorage.setItem('language', 'en');
                this.myInstance.language = new en();
                break;
        }
    }

    static trad(){
        if (Loc.myInstance == null) {
            Loc.myInstance = new Loc();
        }

        return this.myInstance.language;
    }

    static select(){
        if (Loc.myInstance == null) {
            Loc.myInstance = new Loc();
        }

        return this.myInstance.languages;
    }


}